import { cleanInput } from '@exodus/basic-utils';
import { atom, swr } from '@exodus/headless-ui';
import toAssetAtom from './to-asset.js';
import toAmountAtom from './to-amount.js';
import limitsAtom from './limits.js';
import fiatModeAtom from './fiat-mode.js';
const toFiatAmountAtom = atom((get, { selectors }) => {
    const toAsset = get(toAssetAtom);
    const toAmount = get(toAmountAtom);
    return get(selectors.fiatBalances.createAssetConversion(toAsset.name))(toAmount);
}, (get, set, value, { selectors }) => {
    const toAsset = get(toAssetAtom);
    const fiatCurrency = get(selectors.locale.currencyUnitType);
    const convert = get(selectors.fiatBalances.createConversion);
    const cleanedValue = cleanInput(value, fiatCurrency.defaultUnit.power);
    const fiatValue = fiatCurrency.defaultUnit(cleanedValue);
    const cryptoValue = convert(toAsset.name)(fiatValue);
    const limits = get(swr(limitsAtom));
    const minLimit = (!limits.loading && limits.data?.ExactOut.min) || toAsset.currency.ZERO;
    const minLimitFiatAmount = convert(toAsset.name)(minLimit);
    const oneCent = fiatCurrency.defaultUnit(0.01);
    const isAlmostLimitMin = minLimitFiatAmount.sub(fiatValue).abs().lt(oneCent);
    const shuouldUseLimitMin = get(fiatModeAtom) && isAlmostLimitMin;
    set(toAmountAtom, shuouldUseLimitMin ? minLimit : cryptoValue);
});
export default toFiatAmountAtom;
